import {backgroundImageStyle} from '@/utils/background-image';

/**
 * Даёт шаблону метод bgStyle: фон, который не подставляется, если картинки нет.
 * Подробности — в utils/background-image.js.
 */
export const backgroundImageMixin = {
    methods: {
        bgStyle(url) {
            return backgroundImageStyle(url);
        },
    },
};
